module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-1.d708e3e9.jpg";